import React from "react";
import { useLocation } from "react-router-dom";
import MainActions from "./MainActions";
import AccountManagement from "./AccountManagement";

export default function Header() {
  const location = useLocation();
  const path = location.pathname;

  const hideActions = path.startsWith('/profile');

  return (
    <header id="header">
      <img id="logo" src="/assets/media/logo.png" width={32} height={32} />

      {!hideActions && <MainActions />}

      <AccountManagement />
    </header>
  )
}
